import React from 'react';
import { MapPinIcon, MaximizeIcon, AlertTriangleIcon, CheckCircle2Icon, ClockIcon } from 'lucide-react';
interface LandCardProps {
  land: any;
  onClick: () => void;
  t: (key: string) => string;
}
export function LandCard({
  land,
  onClick,
  t
}: LandCardProps) {
  const getStatusColor = (status: string) => {
    if (['Completed', 'Paid', 'None'].includes(status)) return 'text-green-700 bg-green-50 border-green-200';
    if (['Pending', 'Due'].includes(status)) return 'text-amber-700 bg-amber-50 border-amber-200';
    return 'text-red-700 bg-red-50 border-red-200';
  };
  const getStatusIcon = (status: string) => {
    if (['Completed', 'Paid', 'None'].includes(status)) return <CheckCircle2Icon className="w-3 h-3 mr-1" data-id="element-83" />;
    if (['Pending', 'Due'].includes(status)) return <ClockIcon className="w-3 h-3 mr-1" data-id="element-84" />;
    return <AlertTriangleIcon className="w-3 h-3 mr-1" data-id="element-85" />;
  };
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'Agricultural':
        return 'bg-green-100 text-green-800';
      case 'Residential':
        return 'bg-blue-100 text-blue-800';
      case 'Commercial':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-slate-100 text-slate-800';
    }
  };
  const translateStatus = (status: string) => {
    const key = `status.${status.toLowerCase()}`;
    return t(key) !== key ? t(key) : status;
  };
  const translateType = (type: string) => {
    const key = `land.${type.toLowerCase()}`;
    return t(key) !== key ? t(key) : type;
  };
  return <div onClick={onClick} className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-[#006A4E]/40 transition-all cursor-pointer overflow-hidden flex flex-col" data-id="element-86">
      <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50" data-id="element-87">
        <span className="font-mono text-sm font-semibold text-slate-700" data-id="element-88">
          {land.id}
        </span>
        <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${getTypeColor(land.type)}`} data-id="element-89">
          {translateType(land.type)}
        </span>
      </div>

      <div className="p-5 flex-1" data-id="element-90">
        <div className="flex items-start gap-2 mb-4" data-id="element-91">
          <MapPinIcon className="w-5 h-5 text-slate-400 shrink-0 mt-0.5" data-id="element-92" />
          <div data-id="element-93">
            <p className="font-semibold text-slate-800" data-id="element-94">
              {t('land.dag')}: {land.plot}, {t('land.khatian')}: {land.khatian}
            </p>
            <p className="text-sm text-slate-500" data-id="element-95">
              {land.mouza}, {land.upazila}, {land.district}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-4 text-sm text-slate-600" data-id="element-96">
          <MaximizeIcon className="w-4 h-4 text-slate-400" data-id="element-97" />
          <span data-id="element-98">{land.area}</span>
          <span className="mx-2 text-slate-300" data-id="element-99">•</span>
          <span data-id="element-100">
            {land.ownership === 'Sole' ? 'একক' : 'যৌথ'} {t('land.ownership')}
          </span>
        </div>

        <div className="space-y-2 mt-auto" data-id="element-101">
          <div className="flex justify-between items-center text-sm" data-id="element-102">
            <span className="text-slate-500" data-id="element-103">{t('land.taxStatus')}</span>
            <span className={`flex items-center px-2 py-0.5 rounded text-xs border ${getStatusColor(land.tax)}`} data-id="element-104">
              {getStatusIcon(land.tax)} {translateStatus(land.tax)}
            </span>
          </div>
          <div className="flex justify-between items-center text-sm" data-id="element-105">
            <span className="text-slate-500" data-id="element-106">{t('land.mutation')}</span>
            <span className={`flex items-center px-2 py-0.5 rounded text-xs border ${getStatusColor(land.mutation)}`} data-id="element-107">
              {getStatusIcon(land.mutation)} {translateStatus(land.mutation)}
            </span>
          </div>
          {land.dispute !== 'None' && <div className="flex justify-between items-center text-sm mt-2 pt-2 border-t border-slate-100" data-id="element-108">
              <span className="text-slate-500" data-id="element-109">{t('land.dispute')}</span>
              <span className="flex items-center px-2 py-0.5 rounded text-xs border text-red-700 bg-red-50 border-red-200" data-id="element-110">
                <AlertTriangleIcon className="w-3 h-3 mr-1" data-id="element-111" />{' '}
                {t('status.active')}
              </span>
            </div>}
        </div>
      </div>
    </div>;
}